import { useUIStore } from '../stores/ui/ui.store';
import type { Envelope } from './envelope';
import { makeApiRequest, type RequestConfig } from './make-api-request';

const { showErrorToast, showLoading, hideLoading } = useUIStore.getState();

export async function callApiEndpoint<TResult>(config: RequestConfig): Promise<Envelope<TResult>> {
  showLoading();
  let data = {} as Envelope<TResult>;

  try {
    const response = await makeApiRequest(config);
    data = await response.json();
  } catch (ex) {
    data = {
      isFailure: true,
      isSuccess: false,
      errorMessage: 'Unexpectd error',
      result: null as TResult
    };
  } finally {
    hideLoading();

    if (data.isFailure) {
      showErrorToast(data.errorMessage);
    }
  }

  return data;
}

export function makePost<TBody extends Record<string, any> | undefined, TResult>(
  endpoint: string,
  body: TBody
): Promise<Envelope<TResult>> {
  return callApiEndpoint({
    endpoint,
    method: 'POST',
    body
  });
}

export function makeGet<TResult>(endpoint: string): Promise<Envelope<TResult>> {
  return callApiEndpoint({
    endpoint,
    method: 'GET'
  });
}

export function makePatch<TBody extends Record<string, any> | undefined, TResult>(
  endpoint: string,
  body?: TBody
): Promise<Envelope<TResult>> {
  return callApiEndpoint({
    endpoint,
    method: 'PATCH',
    body
  });
}
